export default "__VITE_ASSET__0cf2cc35__"